<template>
  <div class="app-sidebar sidebar-shadow">
    <div class="app-header__logo">
      <router-link to="/">
        <div class="logo-src"></div>
      </router-link>
      <div class="header__pane ml-auto">
        <div>
          <button
            type="button"
            class="hamburger close-sidebar-btn hamburger--elastic"
            data-class="closed-sidebar"
          >
            <span class="hamburger-box">
              <span class="hamburger-inner"></span>
            </span>
          </button>
        </div>
      </div>
    </div>
    <div class="app-header__mobile-menu">
      <div>
        <button
          type="button"
          class="hamburger hamburger--elastic mobile-toggle-nav"
        >
          <span class="hamburger-box">
            <span class="hamburger-inner"></span>
          </span>
        </button>
      </div>
    </div>
    <div class="app-header__menu">
      <span>
        <button
          type="button"
          class="btn-icon btn-icon-only btn btn-primary btn-sm mobile-toggle-header-nav"
        >
          <span class="btn-icon-wrapper">
            <i class="fa fa-ellipsis-v fa-w-6"></i>
          </span>
        </button>
      </span>
    </div>
    <div class="scrollbar-sidebar">
      <div class="app-sidebar__inner">
        <ul class="vertical-nav-menu">
          <!-- Module begins -->
          <li
            class="app-sidebar__heading"
          >
            Modules
          </li>
          <li>
            <a
              href="#/power"
              :class="$route.path == '/power' ? 'mm-active' : ''"
              @click="toggleOption()"
            >
              <i class="metismenu-icon pe-7s-power"> </i>Power
            </a>
          </li>
          <li>
            <a
              href="#/tv"
              :class="$route.path == '/tv' ? 'mm-active' : ''"
              @click="toggleOption()"
            >
              <i class="metismenu-icon pe-7s-monitor"> </i>TV
            </a>
          </li>
          <!-- <li>
            <a
              href="#/data"
              :class="$route.path == '/data' ? 'mm-active' : ''"
              @click="toggleOption()"
            >
              <i class="metismenu-icon pe-7s-global"> </i>Data
            </a>
          </li> -->
          <!-- Module ends -->
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["user", "userType"]),
    currentRoute() {
      return this.$route.name;
    }
  },
  methods: {
    toggleOption() {
      var element = document.getElementById("mainEntry")
      var mobileNavBtn = document.getElementById("mobileNavBtn")
      var isOpen = element.classList[5]
      if (isOpen) {
        element.classList.toggle("sidebar-mobile-open")
        mobileNavBtn.classList.toggle("is-active")
      }
    }
  }
};
</script>
<style scoped></style>
